<template>
    <div>
        <dashboard-1 v-if="view_new_dashboard"></dashboard-1>
        <dashboard v-else></dashboard>
    </div>
</template>

<script>
import {validarPermisoComponente} from '../../plugins/acl';
import Dashboard from '../Dashboard.vue';
import Dashboard1 from '../dashboard/Index.vue';

export default {
    name: 'home',
    components: {
        Dashboard,
        Dashboard1
    },
    data() {
        return {
            view_new_dashboard: null
        };
    },
    created() {
        this.view_new_dashboard = validarPermisoComponente('ver-dashboard-general');
    }
};
</script>
